import INDICADORES from '../../../enums/INDICADORES';

const wIndicadoresDisponiveis = ['DI', 'SELIC', 'IBOV', 'IDIV', 'IFIX', 'IMAB', 'USD'];

/**
 * Retorna os indicadores disponíveis no seletor de rentabilidade.
 *
 * @returns {Array<Object>}
 */
export function getAtivoRentabilidadeIndicadores() {
  // Mantém no comparador apenas os indicadores definidos para rentabilidade.
  return Object.values(INDICADORES).filter(pIndicador =>
    wIndicadoresDisponiveis.includes(pIndicador.indicador_id)
  );
}

/**
 * Indica se o identificador pode ser usado no gráfico de rentabilidade.
 *
 * @param {string} pIndicadorId Identificador do indicador.
 * @returns {boolean}
 */
export function isAtivoRentabilidadeIndicadorAvailable(pIndicadorId) {
  if (!pIndicadorId) {
    return false;
  }

  return getAtivoRentabilidadeIndicadores().some(
    pIndicador => pIndicador.indicador_id === pIndicadorId
  );
}

/**
 * Retorna um indicador inicial válido para o gráfico de rentabilidade.
 *
 * @param {string} pIndicadorId Identificador preferencial.
 * @returns {string}
 */
export function getAtivoRentabilidadeDefaultIndicador(pIndicadorId) {
  return isAtivoRentabilidadeIndicadorAvailable(pIndicadorId) ? pIndicadorId : 'SELIC';
}
